<!-- <div>
    <h3>Are you sure you want to delete <strong>{{ user.name }}</strong>?</h3>
  
    <mat-error>{{ errorMessage }}</mat-error>
  
    <div matDialogActions>
      <button mat-button
              mat-dialog-close
              [mat-dialog-close]="false">
        Cancel
      </button>
  
      <button mat-flat-button
              color="warn"
              type="button"
              [disabled]="isSentRequest"
              (click)="deleteUser()">
        Delete user
      </button>
    </div>
  </div>
   -->
Delete user
